import { createSlice } from '@reduxjs/toolkit';
import { fetchAlbums, deleteAlbum, createAlbum } from '../thunks/albums';
import findIndex from 'lodash/findIndex';

const initialState = {
  albums: [],
  albumName: '',
  albumCreateModalStatus: false,
  fetching: false,
  fetchError: '',
  saving: false,
  saveError: '',
  deleting: false,
  deleteError: '',
  pageNumber: 1,
  perPage: 18,
  meta: {},
};

export const albumsSlice = createSlice({
  name: 'albums',
  initialState,
  reducers: {
    openAlbumCreateModal: (state, action) => {
      state.albumCreateModalStatus = action.payload;
    },
    updateAlbumName: (state, action) => {
      state.albumName = action.payload;
    },
    setAlbumsPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
  },
  extraReducers: {
    [fetchAlbums.pending]: (state) => {
      state.fetching = true;
    },
    [fetchAlbums.fulfilled]: (state, action) => {
      const { meta, albums } = action.payload;
      state.fetching = false;
      state.albums = [...state.albums, ...albums];
      state.meta = meta;
    },
    [fetchAlbums.rejected]: (state, action) => {
      state.fetching = false;
      state.fetchError = action.payload.error;
    },
    [deleteAlbum.pending]: (state) => {
      state.deleting = true;
    },
    [deleteAlbum.fulfilled]: (state, action) => {
      const albumIndex = findIndex(
        state.albums,
        (album) => album.id === action.payload
      );
      state.deleting = false;
      state.albums.splice(albumIndex, 1);
    },
    [deleteAlbum.rejected]: (state, action) => {
      state.deleting = false;
      state.deleteError = action.payload.error;
    },
    [createAlbum.pending]: (state) => {
      state.saving = true;
    },
    [createAlbum.rejected]: (state, action) => {
      state.saving = false;
      state.saveError = action.payload.error;
    },
  },
});

export const { openAlbumCreateModal, updateAlbumName, setAlbumsPageNumber } =
  albumsSlice.actions;
